export class PEPremiumConsentModel{
    isPremiumConsentApplicable: boolean;
    premiumConsentDescription: string;
    isPremiumConsentGiven: boolean;
}